import React from "react";

export const LoadingState = ({ label = "Loading…" }) => (
  <div className="flex items-center justify-center rounded-2xl border border-slate-200 bg-white px-6 py-16 text-sm text-slate-500 shadow-sm">
    {label}
  </div>
);

export const ErrorState = ({ message }) => (
  <div className="rounded-2xl border border-rose-200 bg-rose-50 px-6 py-10 text-center text-sm text-rose-800 shadow-sm">
    {message || "Something went wrong."}
  </div>
);

export const EmptyState = ({ title, description, action }) => (
  <div className="rounded-2xl border border-dashed border-slate-300 bg-white px-6 py-14 text-center shadow-sm">
    <h3 className="text-base font-semibold text-slate-900">{title}</h3>
    {description ? <p className="mt-2 text-sm text-slate-500">{description}</p> : null}
    {action ? <div className="mt-6">{action}</div> : null}
  </div>
);

export const ConfirmDialog = ({
  open,
  title,
  description,
  confirmLabel = "Delete",
  onConfirm,
  onCancel,
  busy = false,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/40 p-4">
      <div className="w-full max-w-md rounded-3xl border border-slate-200 bg-white p-6 shadow-2xl">
        <h3 className="text-lg font-semibold text-slate-900">{title}</h3>
        <p className="mt-2 text-sm text-slate-500">{description}</p>
        <div className="mt-6 flex justify-end gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="rounded-2xl border border-slate-200 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
          >
            Cancel
          </button>
          <button
            type="button"
            disabled={busy}
            onClick={onConfirm}
            className="rounded-2xl bg-rose-600 px-4 py-2 text-sm font-semibold text-white hover:bg-rose-500 disabled:opacity-60"
          >
            {busy ? "Working…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};
